import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { CounterRepository } from '~repositories/CounterRepository';
import { StoresHydrateService } from '~domain/services/StoresHydrateService';

export class HydrateStoresWithCountersUseCase {
    private counterRepository: CounterRepository;
    private storesHydrateService: StoresHydrateService;

    constructor() {
        this.counterRepository = diContainer.get(serviceNames.counterRepository);
        this.storesHydrateService = diContainer.get(serviceNames.storesHydrateService);
    }

    public execute = async () => {
        await this.counterRepository.loadCounters();
        this.storesHydrateService.hydrateStoresWithCountersData();
    };
}
